module.exports = __webpack_public_path__ + "img/x3_en_2025_04_25@2x.a799f093.png";